// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__lfFtd","brand":"navbar_brand__+tTDc"};